import { render } from "./AudienceExpansionWall.vue?vue&type=template&id=35d242c0&scoped=true"
import script from "./AudienceExpansionWall.vue?vue&type=script&lang=js"
export * from "./AudienceExpansionWall.vue?vue&type=script&lang=js"

import "./AudienceExpansionWall.vue?vue&type=style&index=0&id=35d242c0&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d242c0"]])

export default __exports__